import { CustomFormSource } from '@/templates/OrderingFlow/fields'

export const triggerServiceOrderingFlow = ({
  page,
  serviceName,
  serviceType,
  sectionName,
  region,
  formType
}: {
  page?: string
  serviceName?: string
  serviceType?: string
  sectionName?: string
  region?: string
  formType?: CustomFormSource
}): void => {
  const queryParams = new URLSearchParams({
    page: page ?? '',
    category: serviceType ?? '',
    service: serviceName ?? '',
    ref: sectionName ?? '',
    region: region ?? '',
    ...(formType && { formType })
  })
  window.location.href = `/book-a-demo?${queryParams.toString()}`
}
